import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Modal, { ModalText, ModalButton } from "common/modal";

const { ConfirmationText } = ModalText;

type TProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const PaymentMethodModal = ({ visible, onCloseModal }: TProps) => {
  const { t } = useTranslation("my_credits");
  const navigate = useNavigate();
  const toMyBilling = () => {
    const path = "/account/my-billings";
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <Modal
      title={t("NO ACTIVE PAYMENT METHOD")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
      modalWidth="100%"
    >
      <ConfirmationText>
        {t("You currently do not have a default payment method set.")}
      </ConfirmationText>
      <div style={{ display: "flex" }}>
        <ModalButton onClick={toMyBilling}>{t("SET IT NOW")}</ModalButton>
        <ModalButton onClick={onCloseModal}>{t("CLOSE")}</ModalButton>
      </div>
    </Modal>
  );
};

export default PaymentMethodModal;
